import InputData from "./InputData";
import Dropdown from "./Dropdown";
import ButtonIconH from "./ButtonIconH";
import { fileSectionsList } from "../js/fileManagement";
import { useState } from "react";

export function MoveFile({ section, onAccept, onClose }) {
  const [newSection, setNewSection] = useState({ id: "", text: "" });

  // console.log("newSection: ", newSection);

  return (
    <div className="popup-container">
      <div className="ap-container popup-screen">
        <div className="popup-screen-header">
          <span className="popup-screen-header-title">Mover fichero</span>
          <button className="popup-action-icon close-icon" onClick={onClose}>
            <img src="/images/close-white.svg" loading="lazy" alt="Icon"></img>
          </button>
        </div>
        <div
          className={`tab-content ap-content`}
          style={{ overflow: "unset", backgroundColor: "#f9f9f9" }}
        >
          <div className="container-panel fv-col-sec" style={{ gap: 20 }}>
            <div className="opt-table-tooltip grid-2" id="move-file-grid">
              <div className="cell cell-label cell-start-content">
                Sección fichero
              </div>
              <div className="cell cell-label">
                <InputData
                  tabIndex={-1}
                  type="type-only-charnumbers"
                  size={0}
                  input={section.text.toUpperCase()}
                  inactive={true}
                  onChange={() => {}}
                  onClick={() => {}}
                ></InputData>
              </div>
              <div className="cell cell-label cell-start-content">
                Nueva sección
              </div>
              <div className="cell cell-label">
                <Dropdown
                  tabIndex={100}
                  disabled={false}
                  optionList={fileSectionsList.filter(
                    (e) => e.id !== section.id,
                  )}
                  size={0}
                  op={newSection.text}
                  onChange={(e) => {
                    setNewSection(e);
                  }}
                  mandatory={false}
                ></Dropdown>
              </div>
            </div>
            <div
              className="popup-buttons"
              style={{ justifyContent: "center", gap: 20 }}
            >
              <ButtonIconH
                text="Aceptar"
                small={true}
                onClick={() => {
                  const section = fileSectionsList.find(
                    (s) => s.text === newSection.text,
                  );
                  onAccept(section?.id ?? newSection.id);
                }}
              ></ButtonIconH>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
